export function applyFilters(filters, appliedFilterNames, rows) {
  // if no filter is given, return all the rows
  if (!filters) return rows

  let rowsSet = new Set(rows)
  for (const filter of appliedFilterNames.map(name => filters[name]).filter(f => f).filter(f => f.isApplied())) {
    rowsSet = rowsSet.intersection(new Set(filter.filterFn(rows)))
  }
  return rowsSet
}

/**
 * @param {{[name: string]: any}} filters
 * @param {string} filterNameToExclude
 * @returns {string[]}
 */
export function getFilterNamesToApply(filters, filterNameToExclude) {
  const filterNames = Object.keys(filters)
  return filterNames.filter(f => f !== filterNameToExclude)
}

export function createFilterObj(filterObjBase) {
  return {
    items: [],
    ...filterObjBase,
    isApplied: function () {
      return this.items.some(item => item.excluded)
    },
    getExclusionDict: function () {

      return Object.fromEntries(this.items.map(item => [item.text, item.excluded]))
    },
    filterFn: function(rows) {
      const dict = this.getExclusionDict();
      return rows.filter(row => {
        let value;
        
        if (this.filteredPropertyName === "Work_OperationProductionStartTime") {
          value = this.name === "YearFilter"
            ? String(Number(row[this.filteredPropertyName].replace('<span class="date-part">', '').split("/")[0]))
            : String(Number(row[this.filteredPropertyName].replace('<span class="date-part">', '').split("/")[1]));
        } else if (this.filteredPropertyName === "Work_ResultEndTime") {
          // Check if Work_ResultEndTime is empty
          value = row["Work_ResultEndTime"] === "" ? "未完了品" : "完了品";
        } else {
          value = row[this.filteredPropertyName];
        }
        
        return !dict?.[value];
      });
    },
    isExcluded: function (dict, row) {
      if (!dict) return false
      return !!dict[row]
    },
    isFilterOn: function() {
      return this.items.some(item => item.excluded)
    },
    getFilterItems: function (rows, filters) {
      const displayedSet = new Set(
        applyFilters(filters, getFilterNamesToApply(filters, this.name), rows)
          .values()
          .map(row => {
            if (this.filteredPropertyName === "Work_OperationProductionStartTime") {
              return this.name === "YearFilter" 
                ? String(Number(row.Work_OperationProductionStartTime.replace('<span class="date-part">', '').split("/")[0]))
                : String(Number(row.Work_OperationProductionStartTime.replace('<span class="date-part">', '').split("/")[1]));
            } else if (this.filteredPropertyName === "Work_ResultEndTime") {
              return row["Work_ResultEndTime"] === "" ? "未完了品" : "完了品";
            }
            return row[this.filteredPropertyName];
          })
      );

      const exclusionDict = this.getExclusionDict();
      if (this.name === "YearFilter" || this.name === "MonthFilter") {
        const dynamicItems = Array.from(
          new Set(
            rows.map(row => {
              if (this.filteredPropertyName === "Work_OperationProductionStartTime") {
                return this.name === "YearFilter"
                  ? String(Number(row[this.filteredPropertyName].replace('<span class="date-part">', '').split("/")[0]))
                  : String(Number(row[this.filteredPropertyName].replace('<span class="date-part">', '').split("/")[1]));
              } else if (this.filteredPropertyName === "Work_ResultEndTime") {
                return row["Work_ResultEndTime"] === "" ? "未完了品" : "完了品";
              }
              return row[this.filteredPropertyName];
            })
          ).values()
        ).map(row => ({
          text: row,
          displayed: true,
          excluded: this.isExcluded(exclusionDict, row) ?? false,
        }));
        // Merge manually added items
        const manualItems = this.items.filter(item => !dynamicItems.some(d => d.text === item.text));
        return [...dynamicItems, ...manualItems];
      }
      const dynamicItems = Array.from(
        new Set(
          rows.map(row => {
            if (this.filteredPropertyName === "Work_OperationProductionStartTime") {
              return this.name === "YearFilter"
                ? String(Number(row[this.filteredPropertyName].replace('<span class="date-part">', '').split("/")[0]))
                : String(Number(row[this.filteredPropertyName].replace('<span class="date-part">', '').split("/")[1]));
            } else if (this.filteredPropertyName === "Work_ResultEndTime") {
              return row["Work_ResultEndTime"] === "" ? "未完了品" : "完了品";
            }
            return row[this.filteredPropertyName];
          })
        ).values()
      ).map(row => ({
        text: row,
        displayed: displayedSet.has(row),
        excluded: this.isExcluded(exclusionDict, row) ?? false,
      }));

      return dynamicItems;
    }
  }
}